import { useState } from 'react';
import { Alert, Button, Typography } from '@mui/material';
import { RotateCcw } from 'lucide-react';
import { BasketFlowScreen } from '../../../orders/pages/newOrderFlow/configureEquipmentMockup';
import { BasketResponseDTO } from '../../../orders/pages/newOrderFlow/configureEquipmentMockup/types';

type FlowPreviewPanelProps = {
  questionnaire: BasketResponseDTO;
};

/** A mesma tela de configurar equipamento do pedido, alimentada pelo editor. */
export const FlowPreviewPanel = ({ questionnaire }: FlowPreviewPanelProps) => {
  const [resetKey, setResetKey] = useState(0);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          gap: 12,
        }}
      >
        <div>
          <Typography variant="subtitle1" fontWeight={700}>
            Prévia do pedido
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Simulação: responda para ver as perguntas aparecerem. Nada é salvo.
          </Typography>
        </div>
        <Button
          size="small"
          startIcon={<RotateCcw size={14} />}
          onClick={() => setResetKey((key) => key + 1)}
          disabled={questionnaire.questions.length === 0}
        >
          Limpar respostas
        </Button>
      </div>

      {questionnaire.questions.length === 0 ? (
        <Alert severity="info">
          Adicione perguntas ao fluxo para ver como o pedido vai ficar.
        </Alert>
      ) : (
        <div
          style={{
            background: '#fff',
            border: '1px solid #e5e7eb',
            borderRadius: 12,
            padding: 12,
          }}
        >
          <BasketFlowScreen
            key={resetKey}
            embedded
            flow={questionnaire}
            productId={0}
            product={null}
          />
        </div>
      )}
    </div>
  );
};
